
import type { IAPIArticleAuthor } from '@hokify/magazine-interface';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'ArticleAuthorBox',
	components: {},
	computed: {
		authorPageLink(): string {
			return this.authorData?.slug ? `/team/${this.authorData.slug}` : '';
		}
	},
	props: {
		authorData: { type: Object as PropType<IAPIArticleAuthor>, required: true },
		isCompanyPage: { type: Boolean }
	}
});
